import styled from 'styled-components'

export const StyledModal = styled.div`
  && {
    padding: 0;
  }
`

export const StyledSimpleModal = styled.div`
  position: relative;
  width: 360px;
  background-color: #262c4b;
  border-radius: 16px;

  @media screen and (max-width: 640px) {
    width: 100%;
    border-radius: 16px 16px 0 0;
  }
`

export const StyledStatusHead = styled.div`
  position: relative;
  .status-with-tips {
    display: flex;
    padding: 24px 0;
    margin: 0 24px;
    align-items: center;

    .text {
      color: #9081d9;
      margin-left: 10px;
      margin-bottom: 0;
      font-weight: 500;
      font-size: 17px;
    }
    .failed {
      color: #e75b55;
    }
    .success {
      color: #2dba6e;
    }
  }
  .close-icon {
    cursor: pointer;
    position: absolute;
    top: 18px;
    right: 18px;
  }
`

export const StyledSimpleModalBottom = styled.div`
  padding: 0px 15px 19px 20px;
  margin-top: -14px;
  position: relative;
  height: 64px;
  .bottom {
    display: flex;
    justify-content: space-between;
    margin-bottom: -5px;
    span {
      color: ${({ theme }) => theme.colors.textTertiary};
      font-size: 17px;
    }
  }
  .check-btn {
    position: absolute;
    right: 15px;
    top: 20px;
    margin-right: 0;
    color: ${({ theme }) => theme.colors.borderDefault};
    font-size: 13px;
    outline: none;
    border: none;
    cursor: pointer;
    padding: 6px 14px;
    background: #5f55a9;
    border-radius: 8px;
  }
`
